import { ZustandSignInStore } from './types';

export const getActiveSignInFormSelector = (state: ZustandSignInStore) =>
  state.formType;

// ============================ ACTIONS ============================

export const setActiveSignInFormAction = (state: ZustandSignInStore) =>
  state.setFormType;
